/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import './Panel.css';

const Panel = ({ frasePanel, panelSize, onClickHandler }) => {
    useEffect(() => {
        const letras = separarLetras(frasePanel);
        const panel = document.getElementById('panel__frase');
        panel.appendChild(letras);
    }, []);

    function isLetra(letra) {
        if (letra === ' ' || letra === '.' || letra === ',') {
            return false;
        }
        return true;
    }

    function separarLetras(frase) {
        // Normaliza la frase descomponiendo las letras con acentos en letra+acento (NFD)
        // y después replaza los acentos por espacios vacíos
        const fraseNormalizada = frase.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        const fragmentFrase = document.createDocumentFragment();
        const fragmentLetras = document.createDocumentFragment();

        for (let i = 0; i < fraseNormalizada.length; i++) {
            const divPalabra = document.createElement('div');
            divPalabra.classList.add('palabra');

            // Crea un div 'letra' por cada letra con la clase 'letra', o 'no-letra' si es un espacio o punto o coma.
            const divLetra = document.createElement('div');
            if (isLetra(frase[i])) {
                divLetra.classList.add('letra', `letra-${fraseNormalizada[i]}`, 'letra-none');
                divLetra.innerHTML += `<span class="letra__front">${frase[i]}</span>
                                    <span class="letra__back"></span>`;
            } else {
                divLetra.classList.add('no-letra');
                divLetra.innerHTML += `<span class="letra__front">${frase[i]}</span>`;
            }

            fragmentLetras.appendChild(divLetra);

            // Si las letras han completado una palabra, mete todas
            // las letras en un div palabra y comienza un nuevo div palabra.
            if (frase[i] === ' ' || i === (frase.length - 1)) {
                divPalabra.appendChild(fragmentLetras);
                fragmentFrase.appendChild(divPalabra);
            }
        }

        return fragmentFrase;

    }

    return (
    <>
        {panelSize === 'small' ? (
            <div className="panel__container panel__container--small" id="panel__container" onClick={() => onClickHandler()}>
                <div className="panel__frase panel__frase--small" id="panel__frase" />
                <div className="panel--super-small" id="panel--super-small">Ver Panel</div>
            </div>
        ) : (
            <div className="panel__container" id="panel__container" onClick={() => onClickHandler()}>
                <div className="panel__frase" id="panel__frase" />
                <div className="panel--super-small hidden" id="panel--super-small">Ver Panel</div>
            </div>
        )}
    </>
    );
};

export default Panel;
